export default __webpack_public_path__ + "static/media/loading.7242c87c.gif";